import React, { Component } from 'react'
import moment from 'moment'
class Detalhes extends Component {
    rotulosDetail = () => {
        this.props.activateLink()
    }
    render() {
        const row = this.props.row
        const entityDetail = this.props.entityDetail
        console.log("the row is,", row)
        const rotuloRes = this.props.rotuloRes
        return (
            <div className="graphicas mt-3 ml-3">
                <div className="group my-4">
                    <p className="label-name"><strong>Nº Pedido</strong></p>
                    <p className="graphicas-info">{row['idEntidadeAplicacao']}</p>
                </div>
                {
                    (row["tipoSelo"] === 'Incorporado') && 
                    <>
                        <div className="group my-4">
                            <p className="label-name"><strong>Rótulo </strong><span onClick={() => this.rotulosDetail()} style={{cursor: "pointer", color: "red", marginLeft: "100px"}}>Ver detalhes do rótulo</span></p>
                            <p className="graphicas-info">{rotuloRes["características_do_rotulo"] ? rotuloRes["características_do_rotulo"].idrotulo ? rotuloRes["características_do_rotulo"].idrotulo : "nd" : "nd"}</p>
                        </div>
                        <div className="group my-4">
                            <p className="label-name"><strong>Capacidade do Rótulo</strong></p>
                            <p className="graphicas-info">{rotuloRes["características_do_rotulo"] ? rotuloRes["características_do_rotulo"].capasidadenominal ? rotuloRes["características_do_rotulo"].capasidadenominal : "nd" : "nd"}</p>
                        </div>   
                        <div className="group my-4">
                            <p className="label-name"><strong>Local de armazenagem</strong></p>
                            <p className="graphicas-info">{row["instalacaoVinica"] ? row["instalacaoVinica"] : "nd"}</p>
                        </div>
                        <div className="group my-4">
                            <p className="label-name"><strong>Capacidade da garrafa (L)</strong></p>
                            <p className="graphicas-info">{row['litros'] ? row['litros']: "nd"}</p>
                        </div>
                        <div className="group my-4">
                            <p className="label-name"><strong>Volume a disponibilizar</strong></p>
                            <p className="graphicas-info">######</p>
                        </div>
                        
                    </>
                }
                {
                    (!row["tipoSelo"] === "Incorporado") && 
                    <>
                        <div className="group my-4">
                            <p className="label-name"><strong>Data de submissão</strong></p>
                            <p className="graphicas-info">{moment(row['dataCriado']).format('DD/MM/YY')}</p>
                        </div>    
                        <div className="group my-4">
                            <p className="label-name"><strong>Tipo de selo</strong></p>
                            <p className="graphicas-info">{row['tipoSelo'] ? row['tipoSelo'] : "nd"}</p>
                        </div>    
                        <div className="group my-4">
                            <p className="label-name"><strong>Capacidade Lts</strong></p>
                            <p className="graphicas-info">{row['capacidade'] ? row['capacidade']: "nd"}</p>
                        </div>    
                        <div className="group my-4">
                            <p className="label-name"><strong>Papel Cap</strong></p>
                            <p className="graphicas-info">{row['tipoPedido'] ? row['tipoPedido'] : "nd"}</p>
                        </div>    
                        
                    </>
                }   
                <div className="group my-4">
                    <p className="label-name"><strong>Quantidade de selos</strong></p>
                    <p className="graphicas-info">{row['quantidade'] ? parseInt(row['quantidade'].trim()) : "nd"}</p>
                </div> 
                    
                <div className="group my-4">
                    <p className="label-name"><strong>Gráfica</strong></p>
                    <p className="graphicas-info">{row['Gráfica'] ? row['Gráfica'] : "nd"}</p>
                </div> 
                {
                   (!row["tipoSelo"] === "Incorporado") &&
                   <>
                        <div className="entrega-box d-flex my-4 justify-content-between">
                            <div className="group">
                                <p className="label-name"><strong>Local de entrega</strong></p>
                                <p className="graphicas-info">{row['localEntrega'] ? row['localEntrega'] : "nd"}</p>
                            </div>
                            <div className="group graphicas-right-group w-25">
                                <p className="label-name"><strong>Utilizador responsavel pela receção</strong></p>
                                <p className="graphicas-info">{row['responsavelRececao'] ? row['responsavelRececao'] : "nd"}</p>
                            </div>
                        </div>
                   </> 
                }
                
                <div className="group my-4">
                    <p className="label-name"><strong>E-mail de notificação</strong></p>
                    <p className="graphicas-info">{entityDetail['email'] ? entityDetail['email'] : "nd"}</p>
                </div>
                {
                    (!row["tipoSelo"] === "Incorporado") &&
                    <>
                        <div className="group my-4">
                            <p className="label-name"><strong>Estado do pedido</strong></p>
                            <p className="graphicas-info">{row['Estado']}</p>
                        </div>
                    </>    
                }
                
                <div className="entrega-box d-flex my-4 justify-content-between">
                    <div className="group">
                        <p className="label-name"><strong>Data do pedido</strong></p>
                        <p className="graphicas-info">{row['Data de pedido'] ? row['Data de pedido'] : "nd"}</p>
                    </div>
                    <div className="group graphicas-right-group w-25">
                        <p className="label-name"><strong>Hora de pedido</strong></p>
                        <p className="graphicas-info">{moment(row['dataCriado']).format('HH:mm')}</p>
                    </div>
                </div>
                <div className="group my-4">
                    <p className="label-name"><strong>Pedido por </strong></p>
                    <p className="graphicas-info">{row['criadoPor'] ? row['criadoPor'] : "nd"}</p>
                </div>
                {
                    (!row["tipoSelo"] === "Incorporado") ?
                    (<>
                        <div className="group my-4">
                            <p className="label-name"><strong>Data do último estado</strong></p>
                            <p className="graphicas-info">######</p>
                        </div>
                    </>)
                    :
                    (<>
                        <div className="group my-4">
                            <p className="label-name"><strong>Estado</strong></p>
                            <p className="graphicas-info">{row["estado"]}</p>
                        </div>
                    </>)
                }
                
                <div className="group my-4">
                    <p className="label-name"><strong>Utilizador responsável</strong></p>
                    <p className="graphicas-info">{row['criadoPor'] ? row['criadoPor'] : "nd"}</p>
                </div>

                <div>
                { row['tipoSelo'] === 'Incorporado' && (row['estado']==="Pendente" || row['estado']==="Suspenso" || row['estado']==="Aceito" || row['estado']==="Assinalados" || row['estado']==="Destruidos" ) &&
                   <> <p><strong>Relação Requisição/Entrega</strong></p>
                    <table className="w-100 text-center mt-2">
                        <thead className="border">
                            <tr className="d-flex justify-content-start py-2">
                                <td style={{width: "30%"}}><strong>Data de ação</strong></td>
                                <td style={{width: "30%"}}><strong>Entregues</strong></td>
                                <td style={{width: "30%"}}><strong>Por Entregar</strong></td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody className="border">
                            <tr className="d-flex justify-content-start py-2">
                                <td style={{width: "30%"}}>{moment(row['dataCriado']).format('DD/MM/YY')}</td>
                                <td style={{width: "30%"}}>{row['Estado']}</td>
                                <td style={{width: "30%"}}>{row['Estado']}</td>
                                <td className="ml-auto" style={{marginRight: "50px"}}><i className="fas fa-info-circle"></i></td>
                            </tr>
                        </tbody>
                    </table> </> 

                }
                </div>
                   
            </div>
        )
    }
}
export default Detalhes